
import { Box, Button, Typography } from '@mui/material'
import { BoxFC, BoxFR } from 'components/BoxCustom'
import DataGridCellExpand from 'components/DataGridCellExpand/DataGridCellExpand'
import { useCallback, useState, useContext, useEffect } from 'react'
import { GlobalStateContext } from 'contexts/GlobalStateContext'
// import { initFilterData } from './initData'
import { addIdForDataGrid } from 'utils'
import { cSmileColumns, cSmileColumnsCN, cSmileColumnsSc } from './columns'
import { ArticleRounded, CloudDownloadRounded } from 'resource/muiImport'
import { alertError, alertSuccess } from 'components/Alert'
import CusAdvDialog from './CusAdvDialog'
import IsXpssDialog from './IsXpssDialog'

const apiNm = {
  getCSmileData: "/branch/c-smile/getCSmileData",
}
let dataMode = ""
// let lastFilter = null

const CSmile = () => {
  const { ax } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [scDataTable, setScDataTable] = useState([])
  const [cnDataTable, setCNDataTable] = useState([])
  const [selectionModel, setSelectionModel] = useState([])
  const [selectionModelSc, setSelectionModelSc] = useState([])
  const [selectionModelCN, setSelectionModelCN] = useState([])
  const [dialogCusAdvOpen, setDialogCusAdvOpen] = useState(false)
  const [dialogIsXpssOpen, setDialogIsXpssOpen] = useState(false)


  const getData = useCallback(() => {
    ax.post(apiNm.getCSmileData, {}).then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data.invoices, 'InvId'))
        setScDataTable(addIdForDataGrid(value.data.scInvoices, 'ScInvId'))
        setCNDataTable(addIdForDataGrid(value.data.crediteNotes, 'CNId'))
        // lastFilter = filter
      }
    })
  }, [ax])

  // const textFieldProps = useCallback((name) => ({
  //   size: "small",
  //   value: filterData[name] ?? "",
  //   onChange: (e) => setFilterData(o => ({ ...o, [name]: e.target.value || null })),
  //   onKeyUp: (e) => { if (e.key === 'Enter') getData(filterData) },
  // }), [filterData, getData])

  const handleInsertInvoice = useCallback((mode) =>() => {
    if (selectionModel.length === 0) {
      alertError("กรุณาเลือกอย่างน้อย 1 รายการ")
      return
    }
    ax.post("/branch/c-smile/insertCSmileInvoice", { InvIds: selectionModel, Mode: mode }).then(value => {
      if (value.data) {
        getData()
        setSelectionModel([])
        alertSuccess("ลงข้อมูลเรียบร้อยแล้ว")
      }
    })
  }, [ax, selectionModel, getData])

  const handleInsertScInvoice = useCallback((mode) =>() => {
    if (selectionModelSc.length === 0) {
      alertError("กรุณาเลือกอย่างน้อย 1 รายการ")
      return
    }
    ax.post("/branch/c-smile/insertCSmileScInvoice", { InvIds: selectionModelSc, Mode: mode }).then(value => {
      if (value.data) {
        getData()
        setSelectionModelSc([])
        alertSuccess("ลงข้อมูลเรียบร้อยแล้ว")
      }
    })
  }, [ax, selectionModelSc, getData])
  
  const handleInsertCN = useCallback((mode) =>() => {
    if (selectionModelCN.length === 0) {
      alertError("กรุณาเลือกอย่างน้อย 1 รายการ")
      return
    }
    ax.post("/branch/c-smile/insertCSmileCreditNote", { CNIds: selectionModelCN, Mode: mode }).then(value => {
      if (value.data) {
        getData()
        setSelectionModelCN([])
        alertSuccess("ลงข้อมูลเรียบร้อยแล้ว")
      }
    })
  }, [ax, selectionModelCN, getData])

  const handleOpenCusAdvDialog = useCallback(() => {
    setDialogCusAdvOpen(true)
  }, [])

  const handleOpenIsXpssDialog = useCallback(() => {
    dataMode = "invoices"
    setDialogIsXpssOpen(true)
  }, [])
  const handleOpenIsXpssDialogSc = useCallback(() => {
    dataMode = "scInvoices"
    setDialogIsXpssOpen(true)
  }, [])

  const handleOpenIsXpssDialogCN = useCallback(() => {
    dataMode = "crediteNotes"
    setDialogIsXpssOpen(true)
  }, [])
  useEffect(() => {
    getData()
  }, [getData])

  return (
    <BoxFC height='100%' sx={{ gap: 1 }}>
      <BoxFR>

        <Button variant='contained' onClick={() => getData()} ><CloudDownloadRounded sx={{ mr: 1 }} />ดึงข้อมูลยังไม่ลง CSmile</Button>
        <Button variant='contained' onClick={handleOpenCusAdvDialog} >กำหนดค่าสำรองจ่ายตามลูกค้า</Button>
        {/* <Box flex={1} />
        <TextField {...textFieldProps("InvNo")} label="เลขที่ใบแจ้งหนี้" sx={{ width: 200 }} />
        <DateTimeSelect sx={{ width: 180 }} label='วันที่ใบแจ้งหนี้' start={filterData.InvDteSt} end={filterData.InvDteEn}
          setSelectDate={(st, en) => { setFilterData(o => ({ ...o, InvDteSt: st, InvDteEn: en })) }}
          getData={() => { getData(filterData) }}
        />
        <SearchButton onClick={() => getData(filterData)} />
        <ClearButton onClick={() => setFilterData({ ...clearFilterData })} /> */}
      </BoxFR>
      <BoxFR height='100%'>

        <BoxFC height="100%" flex={1} sx={{ gap: 1 }}>
          <BoxFR flex={1}>
            <Typography variant='h6' >รายการใบแจ้งหนี้ยังไม่ลง CSmile</Typography>
            <Button variant="outlined" size="small" onClick={handleOpenIsXpssDialog}>
              <ArticleRounded sx={{mr: 1}} />รายการลง CSmile แล้ว</Button>
          </BoxFR>
          <BoxFR>
            {/* <Button variant='contained' size='small' onClick={handleInsertInvoice("ALL")}>ลงข้อมูลทั้งหมด</Button> */}
            <Button variant='contained' size='small' onClick={handleInsertInvoice("SEPERATE")}>ลงข้อมูลทั้งหมด</Button>
            <Button variant='contained' size='small' onClick={handleInsertInvoice("OWN_ONLY")}>ลงเฉพาะใบเสร็จบริษัท</Button>
            <Button variant='contained' size='small' onClick={handleInsertInvoice("NONE")}>ยกเว้นการลงข้อมูล</Button>
          </BoxFR>
          <Box height='100%'>
            <DataGridCellExpand
              checkboxSelection
              hideFooter
              rows={dataTable}
              columns={cSmileColumns}
              selectionModel={selectionModel}
              onSelectionModelChange={(newSelection) => setSelectionModel(newSelection)}
            />
          </Box>

        </BoxFC>
        <BoxFC height="100%" flex={1} sx={{ gap: 1 }}>
          <BoxFR flex={1}>
            <Typography variant='h6' >รายการวางบิลรถร่วมยังไม่ลง CSmile</Typography>
            <Button variant="outlined" size="small" onClick={handleOpenIsXpssDialogSc}>
              <ArticleRounded sx={{mr: 1}} />รายการลง CSmile แล้ว</Button>
          </BoxFR>
          <BoxFR>
            <Button variant='contained' size='small' onClick={handleInsertScInvoice("SEPERATE")}>ลงข้อมูลทั้งหมด</Button>
          </BoxFR>
          <Box height='100%'>
            <DataGridCellExpand
              checkboxSelection
              hideFooter
              rows={scDataTable}
              columns={cSmileColumnsSc}
              selectionModel={selectionModelSc}
              onSelectionModelChange={(newSelection) => setSelectionModelSc(newSelection)}
            />
          </Box>

        </BoxFC>

        <BoxFC height="100%" flex={0.8} sx={{ gap: 1 }}>
          <BoxFR flex={1}>
            <Typography variant='h6' >รายการใบลดหนี้ยังไม่ลง CSmile</Typography>
            <Button variant="outlined" size="small" onClick={handleOpenIsXpssDialogCN}>
              <ArticleRounded sx={{mr: 1}} />รายการลง CSmile แล้ว</Button>
          </BoxFR>
          <BoxFR>
            <Button variant='contained' size='small' onClick={handleInsertCN("SEPERATE")}>ลงข้อมูลทั้งหมด</Button>
          </BoxFR>
          <Box height='100%'>
            <DataGridCellExpand
              checkboxSelection
              hideFooter
              rows={cnDataTable}
              columns={cSmileColumnsCN}
              selectionModel={selectionModelCN}
              onSelectionModelChange={(newSelection) => setSelectionModelCN(newSelection)}
            />
          </Box>
        </BoxFC>
      </BoxFR>
      <CusAdvDialog dialogOpen={dialogCusAdvOpen} setDialogOpen={setDialogCusAdvOpen} />
      <IsXpssDialog dialogOpen={dialogIsXpssOpen} setDialogOpen={setDialogIsXpssOpen} data={dataMode}/>
    </BoxFC>
  )
}

export default CSmile
